<div>
	<div class="summary-and-filter-container">
		<div>
			<div class="title">{{ client()?.active_text?.name }}</div>
			<app-stride-district-report-summary [report]="report()"></app-stride-district-report-summary>
		</div>
	</div>

	<app-reporting-table [loading]="loading()" [rows]="rows()" [columns]="columns()">
		<!-- Header templates (defines order/keys) -->
		<ng-template appHeaderColumn="productName">Product</ng-template>
		<ng-template appHeaderColumn="name">School</ng-template>
		<ng-template appHeaderColumn="teacherCount">Teachers</ng-template>
		<ng-template appHeaderColumn="sectionCount">Classes</ng-template>
		<ng-template appHeaderColumn="studentCount">Students</ng-template>
		<ng-template appHeaderColumn="activityCount">Activities Completed</ng-template>
		<ng-template appHeaderColumn="activitiesPerStudent">
			<span nz-tooltip="Activities Completed Per Student">Act. Completed Per Student</span>
		</ng-template>
		<ng-template appHeaderColumn="progress">
			<span nz-tooltip="% of upgrades and downgrades across active students">Progress</span>
		</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template appRowColumn="productName" let-row>{{ row.productName }}</ng-template>
		<ng-template appRowColumn="name" let-row>
			@if (row.studentCount > 0) {
				<div class="name-column" (click)="onRowClick(row)">{{ row.name }}</div>
			}
			@if (row.studentCount === 0) {
				<div class="name-column-no-students" nz-tooltip="No students are enrolled">{{ row.name }}</div>
			}
		</ng-template>
		<ng-template appRowColumn="teacherCount" let-row>{{ row.teacherCount | number }}</ng-template>
		<ng-template appRowColumn="sectionCount" let-row>{{ row.sectionCount | number }}</ng-template>
		<ng-template appRowColumn="studentCount" let-row>{{ row.studentCount | number }}</ng-template>
		<ng-template appRowColumn="activityCount" let-row>{{ row.activityCount | number }}</ng-template>
		<ng-template appRowColumn="activitiesPerStudent" let-row>{{ row.activitiesPerStudent | number }}</ng-template>
		<ng-template appRowColumn="progress" let-row>
			<span class="upgraded">
				{{ row.upgraded }}%
				<nz-icon nzType="caret-up" nzTheme="outline" />
			</span>
			<span>/</span>
			<span class="downgraded">
				{{ row.downgraded }}%
				<nz-icon nzType="caret-down" nzTheme="outline" />
			</span>
		</ng-template>
	</app-reporting-table>
</div>
